const localizers = {
  'loading.msg': () => `Läser in...`,
  'logon.message.msg': () => `Autentisering krävs. Ange ett giltigt användar-ID och lösenord.`,
  'logon.button.msg': () => `Inloggning...`,
  'SASServer.logonError.msg': () => `Det går inte att logga in på servern.`,
  'SASServer.genericError.msg': () => `Servern kan inte nås.`,
}
export default localizers;
